import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../context/UserContext";

const OnboardingRoute = ({ children }) => {
  const { user, loading } = useUser();

  if (loading) return <div>Loading...</div>;

  if (!user) return <Navigate to="/login" />;

  if (!user.tncAccepted) return <Navigate to="/tnc" />;

  return children;
};

export default OnboardingRoute;
